export const UPDATE_GENDER_START = 'UPDATE_GENDER_START';
export const UPDATE_GENDER_SUCCESS = 'UPDATE_GENDER_SUCCESS';
export const UPDATE_GENDER_FAILURE = 'UPDATE_GENDER_FAILURE';
export const UPDATE_GENDER_END = 'UPDATE_GENDER_END';
export const CLEAR_UPDATE_GENDER = 'CLEAR_UPDATE_GENDER';
